import { Button } from 'components/Button/Button';
import { showModal } from 'zustand-stores/modalStore';

type Props = {
  hasSocialShare: boolean;
  canSubscribe: boolean;
  isSubscribed: boolean;
  shareUrl: Record<UserLocale, string>;
  subscribe: () => Promise<void>;
};

export function CmsButtonBar({
  canSubscribe,
  hasSocialShare,
  shareUrl,
  subscribe,
  isSubscribed,
}: Props) {
  function handleShare() {
    showModal('SHARE_LISTING', {
      listingType: 'URL',
      messageOverride: getText('Check out this article'),
      shareUrl,
    });
  }

  return (
    <>
      {canSubscribe ? (
        <Button
          type="button"
          variant="secondary"
          onClick={subscribe}
          icon={{ type: 'normalized', name: 'bell' }}
          data-qa-id="button-bar-subscribe-to-subsite"
          disabled={isSubscribed}
          size="medium"
        >
          {isSubscribed ? getText('Subscribed') : getText('Subscribe')}
        </Button>
      ) : null}
      {hasSocialShare ? (
        <Button
          type="button"
          variant="secondary"
          onClick={() => handleShare()}
          icon={{ type: 'normalized', name: 'share' }}
          data-qa-id="button-bar-social-share-button"
          size="medium"
        >
          {getText('Share')}
        </Button>
      ) : null}
    </>
  );
}
